import { ReactNode } from 'react';
import { BookingsProvider } from '@features/cart/hooks/useBookings';

/** Lazy scope: bookings GraphQL only mounts on cart/account/order flows. */
export function BookingsRouteLayout({ children }: { children: ReactNode }) {
  return <BookingsProvider>{children}</BookingsProvider>;
}
